import RichUpdatesPlaceholder from './RichUpdatesPlaceholder';

export default RichUpdatesPlaceholder;
